import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { PAGE_URL } from 'site-modules/shared/constants/page-urls';
import {
  getDealershipStateCityNameUrl,
  getDealershipWriteReviewLink,
} from 'site-modules/shared/utils/dealership-link-constructor';

export function getDealerPageBreadcrumbs(dealerInfo) {
  const { address, name, rooftopLogicalName } = dealerInfo;

  return [
    getHomeBreadcrumb(),
    getBaseBreadcrumb('Dealerships', PAGE_URL.DEALERSHIPS),
    getBaseBreadcrumb(
      name,
      address?.stateName && address?.city
        ? getDealershipStateCityNameUrl({
            state: address.stateName,
            city: address.city,
            dealership: rooftopLogicalName,
          })
        : ''
    ),
  ];
}

export function getDealerReviewPageBreadcrumbs({ dealerInfo, reviewType }) {
  const breadcrumbs = getDealerPageBreadcrumbs(dealerInfo);
  const { address, rooftopLogicalName } = dealerInfo;

  breadcrumbs.push(
    getBaseBreadcrumb(
      `Write ${reviewType.charAt(0).toUpperCase() + reviewType.slice(1)} Review`,
      getDealershipWriteReviewLink({
        state: address.stateName,
        city: address.city,
        dealership: rooftopLogicalName,
        reviewType,
      })
    )
  );

  return breadcrumbs;
}

export function getDealerReviewUpdatePageBreadcrumbs({ dealerInfo, pathname }) {
  return [...getDealerPageBreadcrumbs(dealerInfo), getBaseBreadcrumb('Update Review', pathname)];
}
